export const baseURL = "https://staging.wordsru.com/backend/api/v1";
export const ADMINURL = "https://staging.wordsru.com/backend/";
